/** 非会員お知らせを既読に更新. */
export const READ_NONE_NOTICE = "READ_NONE_NOTICE";